import { Component, Input, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';

import { BaseFormList, MessageService } from '../../../../../../core';

import { CampanhaCliente } from '../campanha-cliente';
import { Cliente } from '../../../../../pessoa/cliente/cliente';
import { TypeaheadClienteComponent } from '../../../../../pessoa/cliente/typeahead';
import { ClienteNomePipe } from '../../../../../pessoa/cliente/pipes';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'sgt-campanha-cliente-form',
    templateUrl: './campanha-cliente-form.component.html',
    styleUrls: ['./campanha-cliente-form.component.less'],
    providers: [
        ClienteNomePipe
    ]
})
export class CampanhaClienteFormComponent implements BaseFormList<CampanhaCliente> {
    @Input() entities: CampanhaCliente[];
    @Input() canEdit = true;

    @ViewChild('form') form: NgForm;
    @ViewChildren('typeaheadCliente') typeaheadsClientes: QueryList<TypeaheadClienteComponent>;

    constructor(private messageService: MessageService,
                private clienteNomePipe: ClienteNomePipe) { }


    /** Ao alterar o cliente no typeahead */
    onChangeCliente(entity: CampanhaCliente, cliente: Cliente) {
        if (cliente) {
            entity.idCliente = cliente.id;
        } else {
            entity.idCliente = null;
        }
    }

    /** Retorna os ID's dos clientes que devem ser ignorados no typeahead para adicionar novos clientes */
    getIdsClientesToIgnore(): number[] {
        const ids: number[] = [];
        this.entities?.forEach(entity => {
            if (entity.idCliente > 0) {
                ids.push(entity.idCliente);
            }
        });

        return ids;
    }

    insert(idCliente: number = null) {
        if (!this.entities) {
            this.entities = [];
        }

        const entity = new CampanhaCliente();
        this.entities.push(entity);

        setTimeout(() => {
            if (idCliente) {
                this.typeaheadsClientes?.last?.setEntity(idCliente);
            }
            this.typeaheadsClientes?.last?.setFocus();
        }, 200);
    }

    delete(index: number) {
        if (index < 0) {
            return;
        }

        const entity = this.entities[index];
        if (entity.idCliente > 0) {
            this.messageService.confirm(`Deseja realmente excluir o cliente ${entity?.cliente?.pessoa ? this.clienteNomePipe.transform(entity.cliente.pessoa.nome, entity.cliente.pessoa.nomeFantasia, entity.cliente.pessoa.codigoIntegracaoErp) : ''}?`).then(result => {
                if (result) {
                    this.deleteFromArray(index);
                }
            });
        } else {
            this.deleteFromArray(index);
        }
    }

    private deleteFromArray(index: number) {
        this.entities.splice(index, 1);
    }

    /** Verifica se os clientes da campanha estão válidos */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];

            if (!entity.idCliente) {
                this.messageService.warning('É necessário informar o cliente ou excluir esse cliente', 'Atenção');
                return false;
            }


            const count = this.entities.filter(entityFilter => entityFilter.idCliente && entityFilter.idCliente === entity.idCliente).length;
            if (count > 1) {
                this.messageService.warning(`O cliente ${entity.cliente.pessoa.nome} já está adicionado. Remova ou altere o cliente duplicado`, 'Não é possível adicionar dois clientes iguais');
                return false;
            }
        }

        // Form válido
        if (this.form.invalid) {
            this.messageService.warning('Informe corretamente todos os campos da promoção de clientes desta campanha', 'Atenção');
            return false;
        }

        return true;
    }

    /** Resolve os clientes presentes na campanha */
    resolve() { }
}
